import React, { useState } from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { hockeyFormatter } from '@nhl/formatter-utilities';

import { commonMessages } from '../../../../../../../utility/commonMessages';
import ShiftChartButton from '../shiftChartButton';

import { PeriodButtonContainer } from './styles';

const ShiftChartButtonsContainer = ({ chartData, gameFormat, onFullGameButtonClick, onPeriodButtonClick }) => {
    const intl = useIntl();
    const fullGame = intl.formatMessage(
        defineMessage({
            defaultMessage: 'Full Game',
            description: 'gameShifts.periodFull',
        }),
    );
    const otText = intl.formatMessage(commonMessages.misc.overtime);
    const soText = intl.formatMessage(commonMessages.misc.shootout);
    const [activePeriod, setActivePeriod] = useState(fullGame);

    const getGameType = (data) => {
        const shiftData = data[0];
        return shiftData ? hockeyFormatter.getGameTypeFromGameId(shiftData.gameId) : '';
    };

    const createPeriodsArray = (data) => {
        // @return: sorted array with duplicates removed [1, 2, 3, 4 ...]
        return data
            .map((shiftData) => shiftData.period)
            .sort()
            .filter((item, pos, array) => !pos || item !== array[pos - 1]);
    };

    const formattedButtonsArray = (data) => {
        const periods = createPeriodsArray(data);

        const locale = window.__SITE_LANGUAGE_CODE__;
        const formattedPeriods = periods
            .filter((period) => !(gameFormat.shootoutInUse && period === gameFormat.maxPeriod)) // remove SO period
            .map((period) => hockeyFormatter.periodsFormatter(period, gameFormat, otText, soText, locale));

        formattedPeriods.push(fullGame);

        return formattedPeriods;
    };

    const generatePeriodButtons = (data) => {
        const gameType = getGameType(data);
        const periods = formattedButtonsArray(data);

        return periods.map((period, index) => {
            const handlePeriodButtonClicked = () => {
                const periodClicked = period === fullGame ? onFullGameButtonClick : onPeriodButtonClick;
                periodClicked(index, gameType, periods);
                setActivePeriod(period);
            };

            return (
                <ShiftChartButton
                    name={period}
                    active={period === activePeriod}
                    onPeriodButtonClick={handlePeriodButtonClicked}
                    key={period}
                />
            );
        });
    };

    if (chartData.length === 0) {
        return null;
    }

    const periodButtons = generatePeriodButtons(chartData);

    return <PeriodButtonContainer>{periodButtons}</PeriodButtonContainer>;
};

export default ShiftChartButtonsContainer;
